"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styles = require("@material-ui/core/styles");

var _classnames = _interopRequireDefault(require("classnames"));

var _solarReact = require("@solar/solar-react");

var _excluded = ["align", "children", "classes", "className", "component", "src", "onClick"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

// TODO: add link with link props (more accessible) or click handler to open image
var ChatImage = function ChatImage(_ref) {
  var _classNames;

  var align = _ref.align,
      children = _ref.children,
      classes = _ref.classes,
      classNameProp = _ref.className,
      componentProp = _ref.component,
      src = _ref.src,
      onClick = _ref.onClick,
      other = _objectWithoutProperties(_ref, _excluded);

  var Component = componentProp || 'div';
  var className = (0, _classnames["default"])(classes.root, (_classNames = {}, _defineProperty(_classNames, classes.alignLeft, align === 'left'), _defineProperty(_classNames, classes.alignRight, align === 'right'), _classNames), classNameProp);
  return /*#__PURE__*/_react["default"].createElement(Component, _extends({
    className: className
  }, other), children && /*#__PURE__*/_react["default"].createElement(_solarReact.ChatText, _extends({
    align: align,
    className: classes.text
  }, other), children), /*#__PURE__*/_react["default"].createElement("img", {
    className: classes.img,
    src: src,
    alt: "",
    onClick: onClick
  }));
};

var styles = function styles(theme) {
  return {
    root: {
      display: 'flex',
      flexDirection: 'column'
    },
    alignLeft: {
      alignItems: 'flex-start'
    },
    alignRight: {
      alignItems: 'flex-end'
    },
    img: {
      display: 'block',
      maxWidth: '100%',
      height: 'auto'
    },
    text: {
      backgroundColor: theme.palette.grey[200],
      marginBottom: 0,
      width: '100%'
    }
  };
};

ChatImage.propTypes = {
  align: _propTypes["default"].oneOf(['left', 'center', 'right']),
  children: _propTypes["default"].node,
  classes: _propTypes["default"].object.isRequired,
  className: _propTypes["default"].string,
  component: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].func]),
  src: _propTypes["default"].string
};
ChatImage.defaultProps = {
  align: 'left',
  children: null,
  className: '',
  src: ''
};

var _default = (0, _styles.withStyles)(styles)(ChatImage);

exports["default"] = _default;